import { endpoint } from "../Config/endpoints";
import { sendRequest } from "./http-service";

export const login = (payload) => {
  return sendRequest(endpoint.auth.LOGIN, "POST", payload);
};

